/*

	-----------------------
	OneTrust Cookie Consent
	-----------------------

	DOCS: 
		- Banner SDK JavaScript API: https://developer.onetrust.com/onetrust/docs/javascript-api


	Custom functionality
	--------------------
	- the OptanonWrapper() fires once all files related to the Cookie consent finished download
	- see SDK reference to see what files are downloaded:
	- https://developer.onetrust.com/onetrust/docs/performance-availability-cookie-script

*/
function OptanonWrapper() {

	const gpcEnabled = navigator.globalPrivacyControl;	// Detect if the browser transmits a GPC (Global Privacy Control) signal
	const cookieBannerContainer = document.getElementById('onetrust-consent-sdk');	// Top level OneTrust container

	// Append the Cookie consent container to the DOM
	document.body.prepend(cookieBannerContainer);

	// Display appropriate text based on GPS signal
	if (gpcEnabled) {
		/*
			In the Banner and Privacy Preference Center are two versions of text:
			1. scenario – no GPS signal is detected: display text in the container with the "gpc-off" class
			2. scenario – GPS signal detected: display text in the container with the "gpc-on" class
		*/
		cookieBannerContainer.classList.toggle("gpc-detected");
	}


	//
	//	Privacy Preference Center (<div id="onetrust-pc-sdk">)
	//
	/*
		1. Expands all category descriptions
		2. Relocate "Reject all" button from bottom to the top
	*/
	function setupPrivacyPreferenceCenter() {
		// No previous interaction with Cookie Consent Banner
		if (!OneTrust.IsAlertBoxClosed()) {

			// Preference Center buttons
			const otPcExpandButton = document.querySelectorAll('.ot-accordion-layout button');	// Expand Category description button
			const otPcRejectAllButton = document.querySelectorAll('.ot-pc-footer .ot-pc-refuse-all-handler');	// "Reject all" button
			const otPcAcceptAllButton = document.getElementById('accept-recommended-btn-handler');	// "Accept all" button
	
			// 1. Expand all Categories description
			for (var i = 0; i < otPcExpandButton.length; i++) {
				otPcExpandButton[i].setAttribute('aria-expanded', 'true');
			}
	
			// 2. Relocate "Reject all" button from bottom to the top (after the "Accept all" button)
			if (otPcRejectAllButton.length > 0 && otPcAcceptAllButton) {
				otPcAcceptAllButton.parentNode.insertBefore(otPcRejectAllButton[0], otPcAcceptAllButton.nextSibling);
			}
		}
	}
	setupPrivacyPreferenceCenter();



	//
	//	Mininalistic Banner Template
	//
	/*
		The function oneTrustMiniBanner() handles following templates
		- Avast – MINIMALISTIC (+ Reject)
		- Avast – MINIMALISTIC (+ Manage)

		DEV notes
		–––––––––
		- The function oneTrustMiniBanner() creates a new HTML template on-the-fly via JavaScript.
		- Text used in the new template extracted from the original OneTrust banner template (<div id="id="onetrust-banner-sdk">).
		- The original OneTrust banner template is hidden via custom CSS (defined in OneTrust admin)
			- if you need to adjust the custom CSS, open one of the following links, click the "Banner" tab, open "Styling" accordion and locate "Custom CSS" textarea

				1. Template
				Name: "Avast – MINIMALISTIC (+ Reject)"
				Link: https://app-de.onetrust.com/cookies/templates/edit/019204a0-3b96-757b-934f-70890d53f323

				2. Template
				Name: "Avast – MINIMALISTIC (+ Manage)"
				Link: https://app-de.onetrust.com/cookies/templates/edit/01948389-38e6-78cc-b1a5-8f16e7028090

				3. Template
				Name: "Avast – UNOBTRUSIVE" but… ––––– … The CORRECT name SHOULD BE: "Avast – MINIMALISTIC (+ Manage) – ROW"
				Link: https://app-de.onetrust.com/cookies/templates/edit/01969aad-1804-7cec-b7ed-19963b27ce02
				NOTES:
					- "Avast – UNOBTRUSIVE" template was modified (text and HTML) into the new minimalistic template for ROW (Rest Of the World) – "Avast – MINIMALISTIC (+ Manage) – ROW"
					- we keep the old template name ("Avast – UNOBTRUSIVE") to keep track in Google Analytics & Google Tag Manager


		- the "oneTrustMiniBannerPolicyLink" element
			- exists only in the "Avast – MINIMALISTIC (...)" templates

	*/


	// Get default Cookie Preferences
	// - to see the settings, go to: OneTrust Admin > "Geolocation Rules" > "Avast Consent Policy"
	const oneTrustCookieGroups = OneTrust.GetDomainData().Groups;

	// Default to false
	var isGpcEnabledInOneTrustAdmin = false;

	// Check if current OneTrust template has GPC enabled
	for (var i = 0; i < oneTrustCookieGroups.length; i++) {
		if (oneTrustCookieGroups[i].IsGpcEnabled) {
			isGpcEnabledInOneTrustAdmin = true; // Set to true if at least one group has IsGpcEnabled as true
			break; // Exit the loop early since we found a true value
		}
	}


	// Get country and state code (and convert it to lowercase – on Preview it returns lowercase, on Production uppercase)
	const countryCode = OneTrust.getGeolocationData().country.toLowerCase();	// Example: 'us' (United States)
	const stateCode = OneTrust.getGeolocationData().state.toLowerCase();		// Example: 'ca' (California)
	const locale = countryCode + '-' + stateCode;								// Example: 'us-ca'

	// Check if "Avast MINIMALISTIC" template is used
	// - only this template contains a link – <a id="oneTrustMini__policy-link"…> – with specific ID
	// - the HTML is defined in OneTrust admin (tab "Banner" > "Content" accordion > "Title & Description" > "Notice description" textarea)
	const oneTrustMiniBannerPolicyLink = document.getElementById('oneTrustMini__policy-link');
	const isMinimalisticBannerUsed = !!oneTrustMiniBannerPolicyLink; // Convert oneTrustMiniBannerPolicyLink to a boolean: true if the element exists, false if not


	/*

		Specific conditions must be met in order to show the minibanner
		===============================================================

		Common conditions
		-----------------
			- !OneTrust.IsAlertBoxClosed() = Visitor hasn't interacted with the banner
			- isMinimalisticBannerUsed = Minimalistic template is set in OneTrust Admin

		Geolocation & GPC support conditions
		------------------------------------
			- isGroup1 = 🇺🇸 US 🟢 GPC-supported states (or any other country/states which supports GPC)
				- GPC is supported by law in these states…
				- nevertheless, the Banner will be shown only if the browser doesn't transmit the GPC signal (if the browser transmit the GPC signal, no banner is needed)
			- isGroup2 = 🇺🇸 US 🔴 GPC-not-supported state
			- isGroup3 = 🌐 ROW (Rest Of the World) 🔴 GPC-not-supported state
			- isGroup4 = 🇺🇸 US 🟢 GPC-supported state && 🟢 GPC signal detected => ❌ Don't show the Minimalistic Banner because the 🟢 GPC signal was detected

	*/
	const shouldDisplayBanner = !OneTrust.IsAlertBoxClosed() && isMinimalisticBannerUsed;
	const isGroup1 = isGpcEnabledInOneTrustAdmin && !gpcEnabled && shouldDisplayBanner;
	const isGroup2 = !isGpcEnabledInOneTrustAdmin && countryCode === 'us' && shouldDisplayBanner;
	const isGroup3 = countryCode !== 'us' && shouldDisplayBanner; // Show the Minimalistic banner in the ROW (Rest Of the World); US has to be excluded, otherwice the banner will be shown when GPS is on and in US GPS supported state (e.g. California)   |    BACKUP – Previous version (1.0.5) ––––> countryCode === 'au' && shouldDisplayBanner
	const isGroup4 = isGpcEnabledInOneTrustAdmin && gpcEnabled && shouldDisplayBanner;	// Not used to determine whether to show the Minimalistic banner. Defined here to simplify the "const otConditionGroup" logic.

	//
	//	Condition Group
	//
	const otConditionGroup = 
		isGroup1 ? 'Group 1.: 🇺🇸 US 🟢 GPC-supported state' :
		isGroup2 ? 'Group 2.: 🇺🇸 US 🔴 GPC-not-supported state' :
		isGroup3 ? 'Group 3.: 🌐 ROW (Rest Of the World) 🔴 GPC-not-supported state' :		//	BACKUP – Previous version (1.0.5) –––– isGroup3 ? 'Group 3.: 🇦🇺 Australia 🔴 GPC-not-supported state'
		isGroup4 ? 'Group 4.: 🇺🇸 US 🟢 GPC-supported state && 🟢 GPC signal detected => ❌ Don\'t show the Minimalistic Banner because the 🟢 GPC signal was detected' :
		'Group 5.: Default Banner Template ("Avast – BLOCKING" or "Avast – REJECT ALL")';


	//
	//	DEV only: Debug data
	//
	const otDebugData = {
		'otConditionGroup': otConditionGroup,
		'countryCode': countryCode,
		'stateCode': stateCode,
		'locale': locale,
		'isGpcEnabledInOneTrustAdmin': isGpcEnabledInOneTrustAdmin,
		'isGpcSignalDetected': !!gpcEnabled,	// Does the browser transmit the GPC signal?
		'isMinimalisticBannerUsed': isMinimalisticBannerUsed,
		'IsAlertBoxClosed': OneTrust.IsAlertBoxClosed()
	};

	// Attach the debug method to the OneTrust object
	OneTrust.debug = function () {
		// Version number – to help us track which version is in production
		console.log(
			'%cAvast MINIMALISTIC banner template - v2.0.0',
			'background: #FF7800; color: #071d2b; padding: 4px 8px; border-radius: 4px; font-size: 14px; font-weight: bold;'
		);
		console.table(otDebugData);
	};

	//
	//	Create the MiniBanner
	//
	function oneTrustMiniBanner() {
		if ( isGroup1 || isGroup2 || isGroup3 ) {
			console.log('Avast MINIMALISTIC banner template - v2.0.0'); // Please retain the version number to help us track which version is in production.
	
			// The new HTML template for the Cookie Consent Banner will be stored here.
			var otMini;

			// Helper classes
			const bannerExpandedClass = 'js-expanded';
			const bannerHiddenClass = 'js-hidden';
	
			// Checks if the page is an Academy page (URL starts with www.avast.com/c-)
			const homepageAttr = document.body.getAttribute('data-homepage');
			const isAcademyPage = homepageAttr ? homepageAttr.includes('/c-academy') : false; // Only the Academy pages have <body data-homepage="/c-academy">

			// Checks if template with the "Reject" button is used
			const isGpcMinimalisticRejectAllTemplate = OneTrust.GetDomainData().BannerShowRejectAllButton; // Returns true when the "Reject" button is shown


			//
			//	1. Retrieve data from the OneTrust object
			//
			const otDomainData = OneTrust.GetDomainData();

			const otData = {
				// The HTML is defined in OneTrust admin (tab "Banner" > "Content" accordion > "Title & Description" > "Notice description" textarea)
				text: document.getElementById('onetrust-policy-text').innerHTML,
				buttons: {
					// The text is defined in OneTrust admin (tab "Banner" > "Content" accordion > "Button set")
					accept: otDomainData.AlertAllowCookiesText || "Accept",
					reject: otDomainData.BannerRejectAllButtonText || "Reject",
					manage: otDomainData.AlertMoreInfoText || "Manage"
				}
			};


			// Test: Data Validation
			/*
			if (otData) {
				console.log("Testing otData values...");
			
				// Create an array of objects to represent the table
				const dataValidationTable = [
					{ Name: "Text", Value: otData.text, Expected: "This site uses" },
					{ Name: "Cookie Policy Link Text", Value: otData.cookiePolicyLink.text, Expected: "cookies" },
					{ Name: "Cookie Policy Link Title", Value: otData.cookiePolicyLink.title, Expected: "More information about your privacy" },
					{ Name: "Cookie Policy Link URL", Value: otData.cookiePolicyLink.url, Expected: "https://www.avast.com/cookies-policy" },
					{ Name: "Accept Button Text", Value: otData.buttons.accept, Expected: "Accept" },
					{ Name: "Reject Button Text", Value: otData.buttons.reject, Expected: "Reject" },
					{ Name: "Manage Button Text", Value: otData.buttons.manage, Expected: "Manage" }
				];
			
				// Log the table
				console.table(dataValidationTable);
			} else {
				console.error("otData is not defined or is null.");
			}
			*/


			//
			// 2. Create OneTrust Mini Banner
			//
			function createOneTrustMiniBanner() {
				//
				// 2.1 Create main container
				//
				otMini = document.createElement('div');
				otMini.id = 'oneTrustMini';
				otMini.tabIndex = 0; // Makes the Banner accessible via keyboard


				//
				//	Mobile: Expand the Banner on 🫆 tap
				//
				otMini.addEventListener('touchend', function (e) {
					// Check if the 'bannerExpandedClass' is already applied
					if (!otMini.classList.contains(bannerExpandedClass)) {
						e.preventDefault(); // Prevent default only if the banner is not expanded (without this, the 'Reject'/'Manage' button was activated when the banner expanded)
						otMini.classList.add(bannerExpandedClass); // Expand the banner
					}
				});

				//
				//	Mobile: Collaps the Banner on scroll
				//
				window.addEventListener('scroll', function () {
					otMini.classList.remove(bannerExpandedClass);
				});


				//
				// 2.2 Create Cookie icon
				//
				const cookieIcon = document.createElement('div');
				cookieIcon.id = 'oneTrustMini__cookie-icon';
				otMini.appendChild(cookieIcon);
	
				//
				// 2.3 Create Content container
				//
				const contentContainer = document.createElement('div');
				contentContainer.id = 'oneTrustMini__content';
				otMini.appendChild(contentContainer);
	
				//
				// 2.3.1 Create Policy Text container
				//
				const policyText = document.createElement('div');
				policyText.id = 'oneTrustMini__text';
				policyText.innerHTML = otData.text;

				//
				// 2.3.2 Create Buttons container
				//
				const buttonsDiv = document.createElement('div');
				buttonsDiv.id = 'oneTrustMini__buttons';
	
				// Create Accept button
				const acceptButton = document.createElement('button');
				acceptButton.id = 'oneTrustMini--accept';
				acceptButton.textContent = otData.buttons.accept;
	
				// Handle click on Accept button
				acceptButton.addEventListener('click', function(){
					OneTrust.AllowAll();  // Accept all cookies; Calls the OneTrust SDK function
					otMini.classList.add(bannerHiddenClass); // Hide the Banner
				});


				// Create secondary button (Reject / Manage)
				const secondaryButton = document.createElement('button');

				if(isGpcMinimalisticRejectAllTemplate) {
					// Create the "Reject" button (California only)
					secondaryButton.textContent = otData.buttons.reject;

					// Handle click on the Reject button
					secondaryButton.addEventListener('click', function(){
						OneTrust.RejectAll(); // Reject all cookies; Calls the OneTrust SDK function
						otMini.classList.add(bannerHiddenClass); // Hide the Banner
					});
				} else {
					// Create the "Manage" button for rest of the US states
					secondaryButton.textContent = otData.buttons.manage;
						
					// Handle click on the Manage button
					secondaryButton.addEventListener('click', function(){
						OneTrust.ToggleInfoDisplay(); // Opens the OneTrust Preference Center
					});
				}

				// Append buttons to the Buttons container
				buttonsDiv.appendChild(acceptButton);
				buttonsDiv.appendChild(secondaryButton);
	
				//
				// 2.3 Append content to the Content container
				//
				contentContainer.appendChild(policyText);
				contentContainer.appendChild(buttonsDiv);
	
				//
				// 2.4 Append the whole Banner to the body
				//
				document.body.appendChild(otMini);

				//
				// 2.5 Preference center – hide the Banner when "Accept all" or "Confirm selection" button is clicked in the Preference center
				//
				const otPcAcceptAllButton = document.getElementById('accept-recommended-btn-handler');	// "Accept all" button
				const otPcConfirmSelectionButton = document.querySelector('.save-preference-btn-handler');	// "Confirm selection" button

				// Handle click on "Accept all" button
				otPcAcceptAllButton.addEventListener('click', function() {
					otMini.classList.add(bannerHiddenClass); // Hide the Banner
				});

				// Handle click on "Confirm selection" button
				otPcConfirmSelectionButton.addEventListener('click', function() {
					otMini.classList.add(bannerHiddenClass); // Hide the Banner
				});
			}
			createOneTrustMiniBanner();


			//
			//	3. Academy pages
			//
			function academyPagesBanner() {
				if (isAcademyPage) {
					// Academy pages have a Sticky Bar. Move Cookie Consent Banner above the Sticky Bar
					function adjustCookieConsentBannerPositionOnAcademyPages() {
						const bodyClasses = document.body.className.split(' ');
					
						// Extract platform class from <body> (for example "os-android")
						function getPlatformClass(classes) {
							for (var i = 0; i < classes.length; i++) {
								if (classes[i].startsWith('os-')) {
									return classes[i];
								}
							}
							return null;
						}
					
						const platformClass = getPlatformClass(bodyClasses);

						//
						//	Get reference to Sticky bars
						//
						/*
							Academy pages are using 3 different sticky bars:
							1. mobileStickyBar – used on Article detail template (example: https://www.avast.com/c-spear-phishing)
							2. desktopStickyBar - used on Article detail template
							3. toolPageStickyBar - used on Tool page template (example: https://www.avast.com/c-virus-removal-tool)
						*/
						const mobileStickyBar = document.querySelector('.sticky-post-widget');
						// Get the Sticky bar currently in use (a bar exists for each platform; retrieve the appropriate one)
						const desktopStickyBar = platformClass ? document.querySelector('.os-detect.' + platformClass + ' .sidebar-widget-transformable') : null;
						const toolPageStickyBar = platformClass ? document.querySelector('.os-detect.' + platformClass + ' .sticky-widget') : null;

						// Adjust position of the Cookie Consent Banner
						function adjustCookieConsentBannerMargin(stickyBar, isVisible) {
							// when the Sticky Bar is visible, get its height and set it as margin to the Cookie Consent Banner.
							// when the Sticky Bar NOT visible, reset margin to 0px
							const height = isVisible ? stickyBar.offsetHeight : 0;
							otMini.style.marginBottom = height + 'px';
						}
					
						function checkMobileStickyBarVisibility() {
							// check if the stickyBar exists and it's not hidden via CSS
							const isVisible = mobileStickyBar && window.getComputedStyle(mobileStickyBar).display !== 'none';
							adjustCookieConsentBannerMargin(mobileStickyBar, isVisible);
						}
					
						function checkDesktopStickyBarVisibility() {
							if (!desktopStickyBar) return;	// check if the stickyBar exists
							const style = window.getComputedStyle(desktopStickyBar);
							// this unique combinations indicates that the stickyBar is sticked to the bottom of the screen and is visible
							const isVisible = style.display === 'flex' && style.position === 'fixed';
							adjustCookieConsentBannerMargin(desktopStickyBar, isVisible);
						}

						function checkToolPageStickyBarVisibility() {
							if (!toolPageStickyBar) return;	// check if the stickyBar exists
							const style = window.getComputedStyle(toolPageStickyBar);
							// this unique combinations indicates that the stickyBar is sticked to the bottom of the screen and is visible
							const isVisible = style.display === 'block' && style.bottom === '0px';
							adjustCookieConsentBannerMargin(toolPageStickyBar, isVisible);
						}

						// Only one Sticky Bar is visible at a time. Call the appropriate function.
						function checkStickyBarVisibility() {
							const viewportWidth = window.innerWidth;
					
							if (viewportWidth < 1056) {
								checkMobileStickyBarVisibility();
								checkToolPageStickyBarVisibility();
							} else {
								checkDesktopStickyBarVisibility();
							}
						}
					
						// Initial visibility check
						checkStickyBarVisibility();
					
						// Re-check visibility on scroll and window resize
						window.addEventListener('scroll', checkStickyBarVisibility);
						window.addEventListener('resize', checkStickyBarVisibility);
					}
					adjustCookieConsentBannerPositionOnAcademyPages();
				}
			}
			academyPagesBanner();
		}
	}
	oneTrustMiniBanner();


	//
	//	Relocate "OK" button to the buttons container
	//
	/*
		The function relocateOKButton() handles following templates:
		- Avast – GPC UNOBTRUSIVE (+ Reject All) (MVP – California)
		- Avast – GPC UNOBTRUSIVE (MVP)
	*/
	function relocateOKButton() {
		var gpcOKButton = document.getElementById("cookieGPCControlButton"), // "OK" button (in fact, this is an <a id="cookieGPCControlButton"> element). It is stored in <p id="onetrust-policy-text"> (text and HTML is defined in OneTrust admin).
			buttonContainer = document.querySelector(".banner-actions-container") // Button container (for the "Reject all", "Manage...")

		if (gpcOKButton) {
			// Relocate the "OK" button (move it to the buttonContainer)
			buttonContainer.appendChild(gpcOKButton);

			// GPC signal is ON
			if (gpcEnabled) {
				gpcOKButton.addEventListener('click', function() {
					OneTrust.Close(); // This will "Confirm" default settings set by the GPS signal (user can predefine his default settings in his browser. GPS signal then "shares" this settings with the Cookie Consent).

					// Cookie consent was closed. Re-enable scroll on the page (used on V2 pages)
					document.body.classList.remove('ot-overflow-hidden');
				});
			}
			// GPC signal is OFF (user's browser doesn't support GPS signal)
			else {
				gpcOKButton.addEventListener('click', function() {
					OneTrust.AllowAll(); // Accept all cookies & hide the OneTrust banner & Hide the overlay

					// Cookie consent was closed. Re-enable scroll on the page (used on V2 pages)
					document.body.classList.remove('ot-overflow-hidden');
				});
			}
		}
	}
	relocateOKButton();
}
